import "~/js/libs/jquery-ui.selectmenu.min.js";
import "~/js/sections/weddings/includes/scroll-below";
import "~/js/libs/jquery.waypoint";
import "~/js/libs/sticky";

const resortMenu = document.getElementById("resort-menu");
const toggleButton = document.getElementById("resort-menu-click");

toggleButton.addEventListener("click", () =>
  resortMenu.classList.toggle("open")
);

document.body.addEventListener("click", (event) => {
  if (
    $(event.target).parents("#resort-menu").length <= 0 &&
    resortMenu.classList.contains("open")
  ) {
    resortMenu.classList.remove("open");
  }
});

const showActiveTab = (target) => {
  const newActive = target;
  const promotion = target.getAttribute("data-country");
  const allPromotions = Array.from(
    document.getElementsByClassName("promotion")
  );
  let promotionNotSelected;

  if (promotion === "all") {
    promotionNotSelected = [];
  } else {
    promotionNotSelected = Array.from(
      document.querySelectorAll(`.promotion:not([data-promotion=${promotion}])`)
    );
  }

  const celebrationsTab = document.getElementById("celebrationsTab");
  const celebrationsPromo = document.getElementById("celebrations_promo");

  function ShowCelebrationsPromo() {
    if (celebrationsTab.classList.contains("active")) {
      celebrationsPromo.classList.remove("hide");
    }
  }
  setTimeout(ShowCelebrationsPromo, 10);

  allPromotions.forEach((promo) => {
    promo.classList.remove("hide");
  });
  promotionNotSelected.forEach((promo) => {
    promo.classList.add("hide");
  });
  // weddingActiveTabCover.style.left = `${newActive.offsetLeft}px`;
  document.querySelector(".weddingTabs li.active").classList.remove("active");
  newActive.classList.add("active");
};

document.addEventListener("click", (event) => {
  if (
    event.target.classList.contains("locationTab") &&
    !event.target.classList.contains("active")
  ) {
    showActiveTab(event.target);

    return false;
  }

  if (
    event.target.className !== "ui-menu-item" &&
    event.target.className !== "ui-selectmenu-text" &&
    event.target.className !==
      "ui-selectmenu-icon ui-icon ui-icon-triangle-1-s" &&
    event.target.className !==
      "ui-selectmenu-button ui-button ui-widget ui-selectmenu-button-closed ui-corner-all"
  ) {
    // $resortSelect.selectmenu('close');
  }

  return true;
});

document.addEventListener("touchstart", (event) => {
  if (
    event.target.classList.contains("locationTab") &&
    !event.target.classList.contains("active")
  ) {
    showActiveTab(event.target);

    return false;
  }

  // if (event.target.className !== 'ui-menu-item' && event.target.className !== 'ui-selectmenu-text' && event.target.className !== 'ui-selectmenu-icon ui-icon ui-icon-triangle-1-s' && event.target.className !== 'ui-selectmenu-button ui-button ui-widget ui-selectmenu-button-closed ui-corner-all') {
  //   $resortSelect.selectmenu('close');
  // }

  return true;
});

// JavaScript to Handle Modal
const modal = document.getElementById("myModal");
const btn = document.getElementById("openModalBtn");
const span = document.getElementById("closeButton");

btn.onclick = function () {
  modal.style.display = "block";
};

span.onclick = function () {
  // console.log('close');
  modal.style.display = "none";
};

// Ensure this only closes the modal if the background (not the content) is clicked
window.onclick = function (event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
};

// JavaScript to Handle Modal 2
const modal2 = document.getElementById("myModal2");
const btn2 = document.getElementById("openModalBtn2");
const span2 = document.getElementById("closeButton2");

btn2.onclick = function () {
  modal2.style.display = "block";
};

span2.onclick = function () {
  // console.log('close');
  modal2.style.display = "none";
};

// Ensure this only closes the modal if the background (not the content) is clicked
window.onclick = function (event) {
  if (event.target == modal2) {
    modal2.style.display = "none";
  }
};
